import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAlbumBySlug } from "../../services/AlbumService";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";

// Lightbox
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

// AOS animation
import AOS from "aos";
import "aos/dist/aos.css";

// Custom style
import "../../assets/css/albumdetail.css";

const getFullUrl = (url) => {
  return url.startsWith("http") ? url : `${process.env.REACT_APP_API_BASE_URL}${url}`;
};

const AlbumDetailPage = () => {
  const { slug } = useParams();
  const [album, setAlbum] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  useEffect(() => {
    AOS.init({ duration: 700 });

    const fetchAlbum = async () => {
      try {
        const data = await getAlbumBySlug(slug);

        const imageUrls = data.images?.map((img) => img.imageUrl) || [];


        setAlbum({
          ...data,
          imageUrls,
        });
      } catch (error) {
        console.error("❌ Không thể tải album:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAlbum();
  }, [slug]);

  const photos = Array.isArray(album?.imageUrls)
    ? album.imageUrls.map((url) => ({
        src: getFullUrl(url),
        width: 3,
        height: 4,
      }))
    : [];

  const renderImageBlock = (photo, index) => {
    return (
      <div
        key={index}
        className="col-xl-4 col-md-6 col-sm-12"
        data-aos="zoom-in"
        style={{ marginBottom: 24 }}
        onClick={() => setLightboxIndex(index)}
      >
        <div
          className="d-block position-relative overflow-hidden rounded-3"
          style={{ cursor: "pointer" }}
        >
          <img
            src={photo.src}
            alt={`Image ${index + 1}`}
            className="img-fluid w-100 hover-zoom"
            style={{
              aspectRatio: "3/4",
              objectFit: "cover",
              transition: "transform 0.3s ease-in-out",
            }}
          />
          <div className="overlay-share">
            <button
              className="btn btn-sm btn-light shadow-sm position-absolute bottom-0 end-0 m-2"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                navigator.clipboard.writeText(photo.src);
                alert("📎 Đã sao chép liên kết ảnh!");
              }}
            >
              Chia sẻ
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <LayoutOne headerTop="visible">
      <SEO title={album ? album.title : "Album Detail"} />
      <Breadcrumb
        pages={[
          { label: "Home", path: "/" },
          { label: "Gallery", path: "/gallery" },
          { label: album?.title || "Loading...", path: `/album/${slug}` },
        ]}
      />

      <div className="container pt-80 pb-80">
        {loading ? (
          <p>Loading album...</p>
        ) : !album ? (
          <p className="text-danger">Album not found.</p>
        ) : (
          <>
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark mb-3">{album.title}</h2>
              <div
                className="album-description text-muted fs-5"
                dangerouslySetInnerHTML={{ __html: album.description }}
              ></div>
            </div>

            <div className="row g-4">
              {photos.map((photo, index) => renderImageBlock(photo, index))}
            </div>

            {lightboxIndex >= 0 && (
              <Lightbox
                mainSrc={photos[lightboxIndex].src}
                nextSrc={photos[(lightboxIndex + 1) % photos.length].src}
                prevSrc={
                  photos[(lightboxIndex + photos.length - 1) % photos.length]
                    .src
                }
                onCloseRequest={() => setLightboxIndex(-1)}
                onMovePrevRequest={() =>
                  setLightboxIndex(
                    (lightboxIndex + photos.length - 1) % photos.length
                  )
                }
                onMoveNextRequest={() =>
                  setLightboxIndex((lightboxIndex + 1) % photos.length)
                }
              />
            )}
          </>
        )}
      </div>
    </LayoutOne>
  );
};

export default AlbumDetailPage;
